import React from 'react';
import './Button.css';

/**
 * Standard button. Variants: primary | secondary | danger | ghost | link.
 *   <Button onClick={...}>Save</Button>
 *   <Button variant="danger" loading={busy}>Delete</Button>
 *   <Button as="a" href="/foo">Go</Button>
 */
export default function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  fullWidth = false,
  as: As = 'button',
  className = '',
  children,
  ...rest
}) {
  const classes = [
    'btn',
    `btn--${variant}`,
    `btn--${size}`,
    fullWidth ? 'btn--full' : '',
    loading ? 'btn--loading' : '',
    className,
  ].filter(Boolean).join(' ');

  const isDisabled = disabled || loading;

  // For <button> default to type="button" so it doesn't submit forms accidentally.
  const typeAttr = As === 'button' && !rest.type ? { type: 'button' } : {};

  return (
    <As
      className={classes}
      disabled={As === 'button' ? isDisabled : undefined}
      aria-busy={loading || undefined}
      {...typeAttr}
      {...rest}
    >
      {loading && <span className="btn__spinner" aria-hidden="true" />}
      <span className="btn__label">{children}</span>
    </As>
  );
}
